import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

type SaveCancelProps = {
  saveAction: () => void;
  cancelAction: () => void;
  createAction?: () => void;
  deleteAction?: () => void;
};

const useStyles = makeStyles(
  createStyles({
    container: {
      display: 'flex',
      margin: '4px',
    },
    button: {
      width: '150px',
      margin: '2px',
    },
  })
);

const SaveCancel: React.FC<SaveCancelProps> = (props: SaveCancelProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
        props.saveAction();
      }}>{t('SaveCancel.保存','保存')}</Button>
      <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
        props.cancelAction();
      }}>{t('SaveCancel.キャンセル','キャンセル')}</Button>
      {
        props.createAction !== undefined ? 
          <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
            if(props.createAction){
              props.createAction()
            }
          }}>{t('SaveCancel.グループ作成','グループ作成')}</Button> : null
      }
      {
        props.deleteAction !== undefined ?
          <Button className={classes.button} variant="contained" color="primary" onClick={(e) => {
            if(props.deleteAction){
              props.deleteAction()
            }
          }}>{t('SaveCancel.グループ削除','グループ削除')}</Button> : null
      }
    </div>
  );
};

export default SaveCancel;
